module.exports = __webpack_public_path__ + "static/media/products.c84707c2.jpg";